module.exports = __webpack_public_path__ + "static/media/icon_nosotros_boletos.3c27bf60.svg";